<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Inventory Modem</h3>
                            <div class="card-tools">
                                <button v-if="selected.length > 0" class="btn btn-warning mr-2" @click="printQRBulk">
                                    <i class="fas fa-qrcode"></i> Cetak QR Terpilih ({{ selected.length }})
                                </button>
                                <button class="btn btn-success" @click="newModal">
                                    <i class="fas fa-plus"></i> Tambah Modem
                                </button>
                            </div>
                        </div>
                        
                        <v-app>
                            <v-main>
                                <div class="container-fluid">
                                    <v-row class="mb-1 mt-2">
                                        <v-col :md="3" :offset-md="5">
                                            <v-select
                                                v-model="filter_jenis"
                                                :items="['Semua', 'Baru', 'Cabutan Modem']"
                                                label="Filter Jenis"
                                                hide-details
                                                single-line
                                                @change="debouncedSearch"
                                            ></v-select>
                                        </v-col>
                                        <v-col :md="4">
                                            <v-text-field
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search (Kode / Merek / No Seri)"
                                                single-line
                                                hide-details
                                                @input="debouncedSearch"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    
                                    <v-data-table
                                        v-model="selected"
                                        show-select
                                        :headers="headers"
                                        :items="datas"
                                        :loading="loading"
                                        :options.sync="options"
                                        :server-items-length="totalDatas"
                                        class="elevation-1"
                                    >
                                        <template v-slot:item.no="{ item, index }">
                                            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
                                        </template>

                                        <template v-slot:item.foto_modem="{ item }">
                                            <a v-if="item.foto_modem" :href="`/storage/${item.foto_modem}`" target="_blank">
                                                <img :src="`/storage/${item.foto_modem}`" alt="Foto" width="50" height="50" style="object-fit: cover;" />
                                            </a>
                                            <span v-else>-</span>
                                        </template>
                                        
                                        <template v-slot:item.actions="{ item }">
                                            <button class="btn btn-xs btn-info" @click="printQRSingle(item.id)" title="Cetak QR Code">
                                                <i class="fa fa-qrcode"></i>
                                            </button>
                                            <button class="btn btn-xs btn-primary" @click="editModal(item)" title="Edit Data">
                                                <i class="fa fa-edit"></i>
                                            </button>
                                            <button class="btn btn-xs btn-danger" @click="deleteData(item.id)" title="Hapus Data">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-main>
                        </v-app>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNewLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addNewLabel" v-show="!editmode">Tambah Data Modem</h5>
                        <h5 class="modal-title" id="addNewLabel" v-show="editmode">Edit Data Modem</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="editmode ? updateData() : createData()" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label>Merek</label>
                                    <input v-model="form.merek" type="text" name="merek" class="form-control" :class="{ 'is-invalid': errors.merek }" required>
                                    <span v-if="errors.merek" class="invalid-feedback">{{ errors.merek[0] }}</span>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Nomor Seri</label>
                                    <input v-model="form.nomor_seri" type="text" name="nomor_seri" class="form-control" :class="{ 'is-invalid': errors.nomor_seri }" required>
                                    <span v-if="errors.nomor_seri" class="invalid-feedback">{{ errors.nomor_seri[0] }}</span>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label>Tanggal Pengadaan</label>
                                    <input v-model="form.tgl_pengadaan" type="date" name="tgl_pengadaan" class="form-control" :class="{ 'is-invalid': errors.tgl_pengadaan }" required>
                                    <span v-if="errors.tgl_pengadaan" class="invalid-feedback">{{ errors.tgl_pengadaan[0] }}</span>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Status</label>
                                    <select v-model="form.status" class="form-control" :class="{ 'is-invalid': errors.status }" required>
                                        <option value="">-- Pilih --</option>
                                        <option value="Tersedia">Tersedia</option>
                                        <option value="Terpakai">Terpakai</option>
                                        <option value="Rusak">Rusak</option>
                                        <option value="Hilang">Hilang</option>
                                    </select>
                                    <span v-if="errors.status" class="invalid-feedback">{{ errors.status[0] }}</span>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Jenis</label>
                                    <select v-model="form.jenis" class="form-control" :class="{ 'is-invalid': errors.jenis }" required>
                                        <option value="">-- Pilih --</option>
                                        <option value="Baru">Baru</option>
                                        <option value="Cabutan Modem">Cabutan Modem</option>
                                    </select>
                                    <span v-if="errors.jenis" class="invalid-feedback">{{ errors.jenis[0] }}</span>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-12 form-group">
                                    <label>Keterangan</label>
                                    <textarea v-model="form.keterangan" name="keterangan" class="form-control" :class="{ 'is-invalid': errors.keterangan }"></textarea>
                                    <span v-if="errors.keterangan" class="invalid-feedback">{{ errors.keterangan[0] }}</span>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-12 form-group">
                                    <label>Foto Modem (Opsional)</label>
                                    <input type="file" ref="foto_modem" class="form-control" accept="image/*" @change="onFileChange">
                                    <span v-if="errors.foto_modem" class="text-danger small">{{ errors.foto_modem[0] }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary" :disabled="submitLoading">
                                <span v-if="submitLoading" class="spinner-border spinner-border-sm"></span> Simpan
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            selected: [],
            editmode: false,
            datas: [],
            totalDatas: 0,
            loading: false,
            submitLoading: false,
            search: '',
            filter_jenis: 'Semua',
            options: {},
            searchTimeout: null,
            form: {
                id: '',
                merek: '',
                nomor_seri: '',
                tgl_pengadaan: new Date().toISOString().slice(0, 10),
                status: 'Tersedia',
                keterangan: '',
                jenis: 'Baru',
                foto_modem: null
            },
            errors: {},
            headers: [
                { text: 'No', value: 'no', sortable: false },
                { text: 'Kode', value: 'kode' },
                { text: 'Merek', value: 'merek' },
                { text: 'No Seri', value: 'nomor_seri' },
                { text: 'Tgl Pengadaan', value: 'tgl_pengadaan' },
                { text: 'Status', value: 'status' },
                { text: 'Jenis', value: 'jenis' },
                { text: 'Foto', value: 'foto_modem', sortable: false },
                { text: 'Aksi', value: 'actions', sortable: false, align: 'center' }
            ]
        }
    },
    watch: {
        options: {
            handler() {
                this.loadDatas();
            },
            deep: true,
        },
    },
    methods: {
        printQRSingle(id) {
            let routeData = this.$router.resolve({ path: '/inventory/modem/print-qr', query: { ids: id } });
            window.open(routeData.href, '_blank');
        },
        printQRBulk() {
            const ids = this.selected.map(item => item.id).join(',');
            let routeData = this.$router.resolve({ path: '/inventory/modem/print-qr', query: { ids: ids } });
            window.open(routeData.href, '_blank');
        },
        debouncedSearch() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.options.page = 1;
                this.loadDatas();
            }, 500);
        },
        loadDatas() {
            this.loading = true;
            const { page, itemsPerPage } = this.options;
            
            axios.get('/api/modem', {
                params: {
                    page: page,
                    per_page: itemsPerPage,
                    search: this.search,
                    jenis: this.filter_jenis === 'Semua' ? '' : this.filter_jenis
                }
            }).then(({ data }) => {
                this.datas = data.data.data;
                this.totalDatas = data.data.total;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        newModal() {
            this.editmode = false;
            this.form = {
                id: '',
                merek: '',
                nomor_seri: '',
                tgl_pengadaan: new Date().toISOString().slice(0, 10),
                status: 'Tersedia',
                keterangan: '',
                jenis: 'Baru',
                foto_modem: null
            };
            this.errors = {};
            if (this.$refs.foto_modem) this.$refs.foto_modem.value = null;
            $('#addNew').modal('show');
        },
        editModal(item) {
            this.editmode = true;
            this.form = {
                id: item.id,
                merek: item.merek,
                nomor_seri: item.nomor_seri,
                tgl_pengadaan: item.tgl_pengadaan,
                status: item.status,
                keterangan: item.keterangan || '',
                jenis: item.jenis,
                foto_modem: null
            };
            this.errors = {};
            if (this.$refs.foto_modem) this.$refs.foto_modem.value = null;
            $('#addNew').modal('show');
        },
        onFileChange(e) {
            this.form.foto_modem = e.target.files[0];
        },
        createData() {
            this.submitLoading = true;
            this.errors = {};
            let formData = new FormData();
            formData.append('merek', this.form.merek);
            formData.append('nomor_seri', this.form.nomor_seri);
            formData.append('tgl_pengadaan', this.form.tgl_pengadaan);
            formData.append('status', this.form.status);
            formData.append('keterangan', this.form.keterangan);
            formData.append('jenis', this.form.jenis);
            if (this.form.foto_modem) {
                formData.append('foto_modem', this.form.foto_modem);
            }

            axios.post('/api/modem', formData)
                .then(() => {
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: 'Data berhasil ditambahkan'
                    });
                    this.loadDatas();
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Terjadi kesalahan'
                        });
                    }
                })
                .finally(() => {
                    this.submitLoading = false;
                });
        },
        updateData() {
            this.submitLoading = true;
            this.errors = {};
            let formData = new FormData();
            formData.append('_method', 'PUT');
            formData.append('merek', this.form.merek);
            formData.append('nomor_seri', this.form.nomor_seri);
            formData.append('tgl_pengadaan', this.form.tgl_pengadaan);
            formData.append('status', this.form.status);
            formData.append('keterangan', this.form.keterangan);
            formData.append('jenis', this.form.jenis);
            if (this.form.foto_modem) {
                formData.append('foto_modem', this.form.foto_modem);
            }

            axios.post('/api/modem/' + this.form.id, formData)
                .then(() => {
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: 'Data berhasil diupdate'
                    });
                    this.loadDatas();
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Terjadi kesalahan'
                        });
                    }
                })
                .finally(() => {
                    this.submitLoading = false;
                });
        },
        deleteData(id) {
            Swal.fire({
                title: 'Apakah Anda yakin?',
                text: "Data yang dihapus tidak dapat dikembalikan!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete('/api/modem/' + id)
                        .then(() => {
                            Toast.fire({
                                icon: 'success',
                                title: 'Data berhasil dihapus'
                            });
                            this.loadDatas();
                        })
                        .catch(() => {
                            Toast.fire({
                                icon: 'error',
                                title: 'Terjadi kesalahan'
                            });
                        });
                }
            })
        }
    },
    created() {
        this.$Progress.start();
        this.$Progress.finish();
    }
}
</script>
